import { TableFiltersAtom } from "@/Components/Table/types";
import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { CartItem, Discount, Garnish, IThemeItem } from "../utils/interfaces";
import { OrderV2 } from "../v2/queries/interfacesV2";
export const JWT = atom<any>(localStorage.getItem("jwt") ?? false);

export const JWTAtom = atom(
  (get) => get(JWT),
  (get, set, newStr: string) => {
    set(JWT, newStr);
    localStorage.setItem("jwt", newStr);
  }
);

export const labelsAtom = atom([]);

export const canSwitchAtom = atom(true);

export const canSoundAtom = atom(
  localStorage.getItem("canSound") === null
    ? false
    : JSON.parse(localStorage.getItem("canSound")),
  (_, set, canSound: boolean) => {
    localStorage.setItem("canSound", String(canSound));
    set(canSoundAtom, canSound);
  }
);

export const branchAtom = atom(
  localStorage.getItem("branchAtom") === null
    ? -1
    : Number(localStorage.getItem("branchAtom")),
  (_, set, branchId: number) => {
    localStorage.setItem("branchAtom", String(branchId));
    set(cartAtom, []);
    set(branchAtom, Number(branchId));
  }
);

export const franchiseAtom = atom(
  localStorage.getItem("franchiseAtom") === null
    ? -1
    : Number(localStorage.getItem("franchiseAtom")),
  (_, set, franchiseId: number) => {
    localStorage.setItem("franchiseAtom", String(franchiseId));
    set(franchiseAtom, Number(franchiseId));
  }
);

export const merchantAtom = atom(
  localStorage.getItem("merchantAtom") === null
    ? -1
    : Number(localStorage.getItem("merchantAtom")),
  (_, set, franchiseId: number) => {
    localStorage.setItem("merchantAtom", String(franchiseId));
    set(merchantAtom, Number(franchiseId));
  }
);

export const tablesFilters = atom<TableFiltersAtom>({});
export const defaultTableSortAtom = atom<{ [key: string]: boolean }>({});

export interface customFiltersAtomProps {
  id: number;
  label: string;
  value: any;
}

export const customFiltersAtom = atom<any>(false);

export const usersShortcutsAtom = atom<any>(false);

export const addExceptionModal = atom<boolean>(false);

export const themeListAtom = atom<IThemeItem[]>([]);

export const themeActionTypeAtom = atom<string>("");


export const websiteUploadedImages = atom<any>({
  sliderImages: [],
  logo: [],
  backgroundImage: [],
});

export const openedRowsInOpeningHoursAtom = atom<any>({});

export const cartAtom = atomWithStorage<CartItem[]>("cart", []);
export const discountFormAtom = atom<Partial<Discount>[]>([]);

const defaultDiscountModalValues: {
  active: boolean;
  defaultValues?: Discount;
  filter: string[];
  isNew: boolean;
} = {
  active: false,
  defaultValues: undefined,
  filter: [],
  isNew: true,
};

export const discountModalAtom = atom(defaultDiscountModalValues);
export const playedOrdersAtom = atom<number[]>([]);

export const receiptActionAtom = atom<string>("");

export const loyalityDiscountModalAtom = atom<boolean>(false);

export const lastestVersionModal = atom(
  localStorage.getItem("latestVersionModal") === null
    ? {
        show: false,
        initial: false,
        isShown: false,
      }
    : JSON.parse(localStorage.getItem("latestVersionModal")),

  (_, set, newLang: any) => {
    localStorage.setItem("latestVersionModal", JSON.stringify(newLang));
    set(lastestVersionModal, newLang);
  }
);

export const modalAtom = atom("");

export const selectedGarnishAtom = atom<Partial<Garnish>>({});

export const fullScreenAtom = atom(false);

export const editOrderAtom = atom<Partial<OrderV2 & { isEditing?: boolean }>>(
  {}
);
export const liveOrdersStatusses = atom<number[], any, any>(
  localStorage.getItem("liveOrdersStatusses") === null
    ? [1, 2, 3, 4, 5, 6, 7]
    : (JSON.parse(localStorage.getItem("liveOrdersStatusses")) as number[]),
  (_, set, status) => {
    localStorage.setItem("liveOrdersStatusses", JSON.stringify(status));
    set(liveOrdersStatusses, status);
  }
);
export const newReviewAtom = atom<boolean>(false);

export const selectedOrdersAtom = atom<OrderV2[]>([]);

export const discountCodeAtom = atom<{ isApplied: boolean; code: string }>({
  isApplied: false,
  code: "",
});

